import { render, staticRenderFns } from "./challenge.vue?vue&type=template&id=64667ec4&scoped=true"
import script from "./challenge.vue?vue&type=script&lang=js"
export * from "./challenge.vue?vue&type=script&lang=js"
import style0 from "./challenge.vue?vue&type=style&index=0&id=64667ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64667ec4",
  null
  
)

export default component.exports